import React, { FC, useState } from 'react'
import { Button, Dropdown, Menu, message } from 'antd'
import flagUK from '../../assets/flag-uk.png'
import flagUS from '../../assets/flag-us.png'
import { useAuth } from '../../providers/AuthProvider'
import { groupService } from '../../services'

interface Group {
	id: string
	name: string
	imageSrc: string
}

const GroupSelector: FC = () => {
	const { user } = useAuth()
	const [userGroupId, setUserGroupId] = useState(user.group)
	const [isLoading, setLoading] = useState(false)

	const groups: Group[] = [
		{
			id: 'uk',
			name: 'United Kingdom',
			imageSrc: flagUK
		},
		{
			id: 'us',
			name: 'United States',
			imageSrc: flagUS
		}
	]

	const changeGroup = async (group: Group) => {
		const previousGroupId = userGroupId
		setUserGroupId(group.id)

		setLoading(true)
		const key = 'updatable'
		message.loading({ content: `Changing region to ${group.name}...`, key, duration: 0 })

		try {
			await groupService.change(group.id)
			window.location.assign('/')
		} catch (error) {
			message.error({ content: 'There was an unexpected problem when attempting to change region', key })
			setUserGroupId(previousGroupId)
			setLoading(false)
		}
	}

	const menu: JSX.Element = (
		<Menu>
			{groups
				.filter(group => group.id !== userGroupId)
				.map(group => (
					<Menu.Item key={group.id} style={{ textAlign: 'center' }} onClick={() => changeGroup(group)}>
						<img src={group.imageSrc} alt={group.name} title={`Change region to ${group.name}`} />
					</Menu.Item>
				))}
		</Menu>
	)

	const currentGroup: Group = groups.find(group => group.id === userGroupId)

	return (
		<>
			<Dropdown overlay={menu} disabled={isLoading}>
				<Button>
					<img src={currentGroup.imageSrc} alt={currentGroup.name} />
				</Button>
			</Dropdown>
		</>
	)
}

export default GroupSelector
